import { Layout } from './components/common/Layout';
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Notifier from "./components/common/Notifier";
import { HomeRoute } from "./components/common/HomeRoute";
import { LoginPage, ProtectedRoute } from "./pages/LoginPage";
import { AdminPage } from "./pages/AdminPage";
import { ProfilePage } from "./pages/ProfilePage";
import { DashboardPage }  from "./pages/DashboardPage";
import { LandingPage }  from "./pages/LandingPage";
import { LogsPage } from './pages/LogsPage';
import { RegisterPage } from "./pages/RegisterPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import { PreferencesPage } from "./pages/PreferencesPage";
import { CalculatorPage } from "./pages/CalculatorPage";
import { StravaCallback } from "./pages/StravaCallback";
import { WorkoutsPage } from "./pages/WorkoutsPage";
import { AnalyticsPage } from './pages/AnalyticsPage';
import { TrainingJournalPage } from './pages/TrainingJournalPage';
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <Notifier />
          <Routes>
            {/* Страница входа - БЕЗ Layout */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password/:uid/:token" element={<ResetPasswordPage />} />

            {/* Главная страница для гостей - БЕЗ Layout (полноэкранная) */}
              <Route path="/" element={<HomeRoute />} />
              <Route path="/home" element={<LandingPage />} />

            {/* Все остальные страницы внутри Layout */}
            <Route element={<Layout />}>
              <Route path="/calculator" element={<CalculatorPage />} />
              <Route
                path="/onboarding"
                element={
                  <ProtectedRoute requireAuth allowGuest={false}>
                    <OnboardingPage />
                  </ProtectedRoute>
                }
              />
              <Route
                  path="/journal"
                  element={
                    <ProtectedRoute requireAuth>
                      <TrainingJournalPage />
                    </ProtectedRoute>
                  }
                />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route
                path="/preferences"
                element={
                  <ProtectedRoute requireAuth allowGuest={false}>
                    <PreferencesPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute requireAuth>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/workouts"
                element={
                  <ProtectedRoute requireAuth>
                    <WorkoutsPage />
                  </ProtectedRoute>
                }
              />



              <Route
                  path="/settings/strava-callback"
                  element={<StravaCallback />}
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute requireAuth allowGuest={false}>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route path="/logs" element={<LogsPage />} />

              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
            </Route>

            {/* Редирект */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;